var _ellipse, _path, _circle, _ellipse2, _ellipse3, _circle2, _circle3, _ellipse4, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 982,
    height: 970,
    viewBox: "0 0 982 970",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 491,
    cy: 484.5,
    rx: 491,
    ry: 484.5,
    fill: "#E4ECF7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M272.161 51C180.755 138.991 124 261.872 124 397.833C124 665.415 343.828 882.333 615 882.333C693.633 882.333 767.948 864.092 833.838 831.666C745.349 916.848 624.386 969.333 491 969.333C219.828 969.333 0 752.415 0 484.833C0 294.843 110.824 130.397 272.161 51Z",
    fill: "#B8CBE5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 362,
    cy: 329.333,
    r: 67,
    fill: "#B8CBE5"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 700.5,
    cy: 443.333,
    rx: 94.5,
    ry: 95,
    fill: "#B8CBE5"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 654,
    cy: 224.833,
    rx: 49,
    ry: 48.5,
    fill: "#B8CBE5"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 410.5,
    cy: 633.833,
    r: 31.5,
    fill: "#B8CBE5"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 702.5,
    cy: 669.833,
    r: 31.5,
    fill: "#B8CBE5"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 878,
    cy: 513.833,
    rx: 21,
    ry: 21.5,
    fill: "#B8CBE5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 434.5,
    cy: 112.833,
    r: 27.5,
    fill: "#B8CBE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.0a9f5eedec3af68112350f412cfc472f.svg";
export { ForwardRef as ReactComponent };